import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { color } from '@magalu/stereo-ui-styles';
export var Container = styled.div.attrs(function () {
  return {
    bg: 'background.primary',
    justifyContent: 'center'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  ", "\n\n  ul > li:nth-last-child(-n + 2) > div:last-child {\n    right: 0;\n  }\n"])), color);